/**
 * Những màn hình phòng khám hiện tại được dùng theo gói (ADR-0053).
 * Real GET /api/v1/me/screens.
 *
 * Máy chủ gửi CẢ danh mục kèm cờ `allowed`, không chỉ danh sách được phép: bộ chặn đường dẫn phải
 * phân biệt "đường dẫn của một màn hình không có trong gói" (chặn) với "đường dẫn không thuộc màn
 * hình nào" (trang cá nhân, chuyển hướng — để yên).
 */
import { apiClient } from "./client";
import type { OperatingModule } from "./operatingMode";

export interface PlanScreen {
  code: string;
  /** Tiền tố đường dẫn màn hình này sở hữu; trang con thuộc về màn hình sở hữu tiền tố. */
  routes: string[];
  allowed: boolean;
}

export interface PlanScreensView {
  /** Chặn theo gói đã bật cho phòng khám này chưa. Chưa bật thì mọi màn hình đều `allowed`. */
  enforced: boolean;
  screens: PlanScreen[];
  /** Các vùng API gói đang mở. Giao với module của chế độ vận hành mới ra vùng dùng được. */
  zones: OperatingModule[];
}

export const planScreensApi = {
  mine(): Promise<PlanScreensView> {
    return apiClient.get<PlanScreensView>("/v1/me/screens").then((r) => r.data);
  },
};

export const planScreensQueryKeys = {
  mine: () => ["me", "screens"] as const,
};
